import React, { useEffect, useState } from 'react';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import { useParams } from 'react-router-dom';

import * as S from './styles';
import { useNotification } from '../../../context/NotificationContext';
import { TOKEN_USER } from '../../../services/auth';
import Loading from '../../../components/Loading';
import TableContent from './TableContent';
import OperationsMiddle from './OperationsMiddle';

export function PaimentBillsReport() {
  const { setAnchorId } = useNotification();
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const [anchors, setAnchors] = useState([]);
  const [selectedAnchor, setSelectedAnchor] = useState(null);
  const [proposeProps, setProposeProps] = useState({ isPropose: false, origin: '' });
  const [intervalTime, setintervalTime] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [headerData, setHeaderData] = useState();
  const [tableData, setTableData] = useState();
  const [totalTableData, setTotalTableData] = useState();
  const [totalTableColumn, setTotalTableColumn] = useState();
  const [totalTableRow, setTotalTableDataRow] = useState();
  const [triggerUpdate, setTriggerUpdate] = useState(true);
  const [updateContent, setUpdateContent] = useState(Date.now());

  const fetchAvailableAnchors = async () => {
    const { data } = await api.get(
      `Relatorios/ConsultarPlataformasAncorasAnalistas?loginId=${loginId}&moduloId=Relatorio006ContasAPagar`,

    );
    if(data.resposta.redes || data.resposta.plataformas || data.resposta.redeCapittale) {
      const anchor = data.resposta.redeCapittale.ancoraId > 0 ? data.resposta.redeCapittale :
      (data.resposta?.redes.length > 0 ? data.resposta?.redes[0] : 
        (data.resposta?.plataformas.length > 0 ? data.resposta.plataformas[0]: {}));
      setAnchors(data.resposta);
      setSelectedAnchor(anchor);
      setAnchorId(anchor.ancoraId ? anchor.ancoraId : (anchor.plataformaId ? anchor.plataformaId : 0));
    } else if (data.resposta.length > 0) {
      setAnchors(data.resposta);
      setSelectedAnchor(data.resposta[0]);
      setAnchorId(data.resposta[0].ancoraId);
    } else {
      setAnchors([]);
      setSelectedAnchor({});
      setAnchorId(0);
    }
  };

  const handleSelectAnchor = (anchor) => {
    setAnchorId(anchor?.ancoraId);
    setSelectedAnchor(anchor);
    setTriggerUpdate(true)
  };

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(Date.now()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    isLoading
      ? localStorage.setItem('isLoading', 'true')
      : localStorage.setItem('isLoading', 'false');
    setTimeout(() => {
      setLoader(localStorage.getItem('isLoading') === 'true');
    }, 200);
  }, [isLoading]);

  useEffect(() => {
    fetchAvailableAnchors();
    setintervalTime(
      Number(
        JSON.parse(
          sessionStorage.getItem('@Capittale-Web-Setting'),
        )?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)?.valor ?? 0,
      ) *
        1000 *
        60,
    );
  }, []);

  return (
    <S.Root>
      <Header />
      <Subheader title={'Contas a Pagar'} back="/app/home" />
      <S.Content style={{ display: 'flex' }}>
        <div
          style={{
            width: '100%',
            margin: '30px 30px',
            padding: '0px 20px 20px 20px',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
          }}
        >
          <OperationsMiddle
            setTableData={setTableData}
            setHeaderData={setHeaderData}
            setTotalTableColumn={setTotalTableColumn}
            setTotalTableDataRow={setTotalTableDataRow}
            // setTotalTableData={setTotalTableData}s
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            anchors={anchors}
            handleSelectAnchor={handleSelectAnchor}
            selectedAnchor={selectedAnchor}
            triggerUpdateAnchor={triggerUpdate}
            setTriggerUpdateAnchor={setTriggerUpdate}
          />
        </div>
      </S.Content>
      {loader ? (
        <Loading />
      ) : (
        <div>
          <TableContent
            tableData={tableData}
            headerData={headerData}
            totalTableData={totalTableData}
            totalTableColumn={totalTableColumn}
            totalTableRow={totalTableRow}
          />
        </div>
      )}
    </S.Root>
  );
}
